import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { TranslateModule } from '@ngx-translate/core'
import { LocalStorage } from 'ngx-store'

import { ClickBlockingDirective } from 'common/util'

interface ExportPreset {
  name: string
  read: () => Promise<string>
}

export enum SequenceRenderScope {
  WorkArea = 0,
  InOut = 1,
  Entire = 2,
}

export interface SequenceRenderParams {
  name: string
  scope: SequenceRenderScope
  presetContent: string // contents of the EPR file
}

@Component({
  selector: 'premiere-render-sequence-modal',
  templateUrl: './premiereRenderSequenceModal.component.html',
  imports: [
    FormsModule,
    TranslateModule,
    ClickBlockingDirective,
  ],
})
export class PremiereRenderModalComponent {
  SequenceRenderScope = SequenceRenderScope

  builtinExportPresets: ExportPreset[] = [
    {
      name: 'Adobe HQ 1080p HD',
      read: () => fetch(new URL('assets/panelExportPresets/High Quality 1080p HD.epr', document.baseURI))
        .then((response) => response.text()),
    },
  ]
  customPresets: ExportPreset[] = []

  @LocalStorage('premiereProSequenceRenderName') name = 'Sequence'
  @LocalStorage('premiereProSequenceRenderScope') scope = SequenceRenderScope.Entire
  @LocalStorage('premiereProSequenceRenderPreset') lastPresetName = this.builtinExportPresets[0]!.name
  @LocalStorage('premiereProSequenceRenderCustomPresets') customPresetPaths: string[] = []

  preset = this.builtinExportPresets[0]!

  // Host-agnostic file picker, supplied by the interface that opens this
  pickFile: () => Promise<string | undefined> = () => Promise.resolve(undefined)

  constructor (
    private modalInstance: NgbActiveModal,
  ) { }

  ngOnInit () {
    this.preset = this.builtinExportPresets.find(x => x.name === this.lastPresetName) ?? this.builtinExportPresets[0]!
    this.rebuildCustomPresets()
  }

  rebuildCustomPresets () {
    const fs = window['nodeRequire']('fs')
    const nodePath = window['nodeRequire']('path')

    this.customPresets = []
    for (const path of this.customPresetPaths.slice()) {
      if (!fs.existsSync(path)) {
        this.customPresetPaths = this.customPresetPaths.filter(x => x !== path)
        continue
      }
      this.customPresets.push({
        name: path.split(nodePath.sep).pop()!,
        read: () => new Promise((resolve, reject) => {
          fs.readFile(path, (err, data) => {
            if (err) {
              reject(err)
            } else {
              resolve(data.toString())
            }
          })
        }),
      })
    }
  }

  async pickPresetFile () {
    const path = await this.pickFile()
    if (!path) {
      return
    }
    this.customPresetPaths = this.customPresetPaths.filter(x => x !== path)
    this.customPresetPaths.push(path)
    this.rebuildCustomPresets()
    this.preset = this.customPresets[this.customPresets.length - 1]!
  }

  render = async () => {
    this.lastPresetName = this.preset.name
    const presetContent = await this.preset.read()
    this.modalInstance.close({
      name: this.name,
      scope: this.scope,
      presetContent,
    })
  }

  cancel () {
    this.modalInstance.dismiss()
  }
}
